export default __webpack_public_path__ + "static/banner-ai-2f6e8529406bb5095fed733a56fd036a.png";